import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-teal-50 to-green-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-4 border-gray-300">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-gray-500" />
          </div>
          <h2 className="text-3xl font-bold text-gray-700 mb-2">Payment Cancelled</h2>
          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges were made to your account.
          </p>
          
          <div className="space-y-3">
            <Link to="/">
              <Button className="w-full bg-gradient-to-r from-blue-500 to-teal-500 text-white">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Button>
            </Link>
            <Link to="/book">
              <Button variant="outline" className="w-full">
                View Book
              </Button>
            </Link>
            <Link to="/coaching">
              <Button variant="outline" className="w-full">
                View Coaching
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
